<template>
    <div class="order-status-graphic-icon">
        <previously-completed v-if="status === 'completed'" />
        <current-status v-if="status === 'current'" />
        <last-step v-if="status !== 'current' && status !== 'completed' && isLast"/>
    </div>
</template>

<script>
import PreviouslyCompleted from "./icons/previously-completed";
import CurrentStatus from "./icons/current-status";
import LastStep from "./icons/last-step";
export default {
    name: "order-status-graphic-icon",
    components: {LastStep, CurrentStatus, PreviouslyCompleted},
    props: ["status", "isLast"]
}
</script>

<style scoped>
.order-status-graphic-icon{
    width: 45px;
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
